<template lang="pug">
.member-content
  .member-title {{ $t("ui.withdraw") }}
    .member-form
      form(@submit.prevent="addWithdrawTicket")
        .form-field
          .form-label {{ $t("ui.amount") }}
          .input-group
            input.form-control.amount(
              type='text'
              v-model.trim.lazy="$v.withdrawAmount.$model"
              :placeholder="$t('ui.tooltips.withdraw_amount', { 'min': minWithdraw(), 'max': maxWithdraw() })"
              :disabled="loading"
            )
          ValidateResult(:value="$v.withdrawAmount" :name="$t('ui.amount')")  
        .btn-form.py-2.py-xl-3
          a(href='javascript:void(0);' @click="addWithdrawTicket()")
            .btn-submit {{ $t("ui.submit") }}

</template>

<script>
import { required, numeric, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
  components: {
    ValidateResult: () => import("@/library/ValidateResult")
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      withdrawAmount: ""
    }
  },
  validations: {
    withdrawAmount: {
      required,
      numeric,
      minValue(value) {
        return minValue(1)(value);
      },
      maxValue(value) {
        return this.balance > 30000 ? maxValue(30000)(value) : maxValue(this.balance)(value);
      }
    },
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    balance() {
      return this.$store.getters.balance
    },  
  },
  mounted() {
    $('input.amount').on('focus', function() {
      const value = $('input.amount')[0].value;
      $('input.amount')[0].type = 'number';
      $('input.amount')[0].value = Number(value.replace(/,/g, ''))
    });

    $('input.amount').on('blur', function() {
      const value = $('input.amount')[0].value;
      let trimmedString = value.replace(/^0+/, '');
      $('input.amount')[0].type = 'text';
      $('input.amount')[0].value = trimmedString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    });
  },
  methods:{
    minWithdraw() {
      return 1
    },
    maxWithdraw() {
      return this.balance > 30000 ? this.balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '30,000'
    },
    addWithdrawTicket(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if(this.sessionToken) {
          let login_id = this.accountID
          let auth_token = this.sessionToken
          let amount = this.withdrawAmount          
          this.loading = true
          this.$store
            .dispatch("user/addWithdrawTicket", { login_id, auth_token, amount })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {   
                this.reset()
                this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.withdraw_success"), "success")
              } else {
                this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error")
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false              
              this.feedback.status = this.$t("error." + response.status)
              this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error")
            });
        }
      }
    },
    reset() {
      this.feedback.success = true
      this.feedback.status = ""
      this.withdrawAmount = ""
      this.$v.$reset()
    }
  }
}
</script>